import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
export var addFilters = function addFilters(filters, sortFunction) {
  return {
    type: 'ADD_FILTERS',
    newFilters: filters,
    sortFunction: sortFunction
  };
};
export var removeFilter = function removeFilter(id) {
  return {
    type: 'REMOVE_FILTER',
    id: id
  };
};
export var replaceAllFilters = function replaceAllFilters(newFilters) {
  return {
    type: 'REPLACE_ALL_FILTERS',
    newFilters: newFilters
  };
};
export var updateFilterState = function updateFilterState(filterId, isChecked, isVisible) {
  return {
    type: 'UPDATE_FILTER_STATE',
    filterId: filterId,
    isChecked: isChecked,
    isVisible: isVisible
  };
};
export var replaceAllFiltersAndMaintainChecked = function replaceAllFiltersAndMaintainChecked(newFilters) {
  return {
    type: 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED',
    newFilters: newFilters
  };
};
function reducer(state, action) {
  switch (action.type) {
    case 'ADD_FILTERS':
      {
        if (action.newFilters.length === 0) {
          return state;
        }
        var newState = _toConsumableArray(state);
        action.newFilters.forEach(function (f) {
          var index = state.findIndex(function (filter) {
            return filter.id === f.id;
          });
          if (index === -1) {
            newState.push(f);
          } else {
            newState[index] = f;
            return newState;
          }
        });
        action.sortFunction && newState.sort(action.sortFunction);
        return newState;
      }
    case 'UPDATE_FILTER_STATE':
      {
        var index = state.findIndex(function (filter) {
          return filter.id === action.filterId;
        });
        if (index === -1) {
          return state;
        }
        var _newState = _toConsumableArray(state);
        _newState[index] = _objectSpread(_objectSpread({}, _newState[index]), {}, {
          isChecked: action.isChecked,
          isVisible: action.isVisible === undefined || action.isVisible === null ? _newState[index].isVisible : action.isVisible
        });
        return _newState;
      }
    case 'REMOVE_FILTER':
      {
        return _toConsumableArray(state.filter(function (filter) {
          return filter.id !== action.id;
        }));
      }
    case 'REPLACE_ALL_FILTERS':
      {
        return _toConsumableArray(action.newFilters);
      }
    case 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED':
      {
        var _newState2 = action.newFilters.map(function (newFilter) {
          var existingFilter = state.find(function (f) {
            return f.id === newFilter.id;
          });
          if (existingFilter && newFilter.isVisible) {
            newFilter.isChecked = existingFilter.isChecked;
          }
          return newFilter;
        });
        return _newState2;
      }
    default:
      // exhaustive check
      var _ = action;
      throw new Error(_);
  }
}
export var useFilter = function useFilter(initialValues) {
  var _React$useReducer = React.useReducer(reducer, initialValues ? initialValues : []),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    dispatch = _React$useReducer2[1];
  var value = React.useMemo(function () {
    return {
      filters: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return value;
};